import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnInit} from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {TeTemplateDto} from "../../../model/dto/entity/te-template.dto";
import {TeTemplateService} from "../../../service/api/te-template.service";
import {TinymceAutosave} from '../../../logic/tinymce-autosave';
import {TestCaseChangeEvent, TeTestCaseComponentVariableWithMapping} from "../te-test-case/te-test-case.component";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {TeTemplateGenerateResponseDto} from "../../../model/dto/entity/te-template-generate-response.dto";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {TeTemplateVariableService} from "../../../service/api/te-template-variable.service";
import {TeTestCaseVariableDto} from "../../../model/dto/entity/te-test-case-variable.dto";
import {TeVariableTypeEnum} from "../../../enum/te-variable-type.enum";
import {TeEditorSaveEvent} from "../te-editor/te-editor.component";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {NavigationItem} from "../../../../../core/shared/dto/navigation/navigation-item";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {ObjectIdentifierWithId} from "../../../../../core/shared/basic/object-identifier.with.id";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";

@Component({
    selector: 'mvs-te-template-object',
    templateUrl: './te-template-object.component.html',
    styleUrls: ['./te-template-object.component.scss'],
    standalone: false
})
export class TeTemplateObjectComponent
    extends ObjectBaseComponent
    implements OnInit, OnChanges {

    testCaseService: MvsCrudService;
    testCaseVariablesService: MvsCrudService;
    dto: TeTemplateDto;
    crudService: TeTemplateService;

    widgetBasicData: WidgetData;
    showBasicData: boolean;
    private autoSave = new TinymceAutosave();
    leftSidebarOpen: boolean = false;
    rightSidebarOpen: boolean = false;
    selectedTestCase: TestCaseChangeEvent;
    activeTabEditor: number = 1;
    activeTab1: number = 0;
    queryParamSubscription: Subscription;
    selectedNavigationItem: string;
    navigationItems: NavigationItem[];

    templateGenerateResponse: TeTemplateGenerateResponseDto;
    trustedGenerateResponseHtml: SafeHtml;
    occurredException: string;
    occurredExceptionDetails: string;

    testCaseDtoList: DtoList;
    variables: TeTestCaseComponentVariableWithMapping[];
    testCaseVariables: TeTestCaseVariableDto[];

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected route: ActivatedRoute,
        protected router: Router,
        public sanitizer: DomSanitizer,
        protected templateVariableService: TeTemplateVariableService,
        protected templateService: TeTemplateService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService) {

        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.testCaseService = this.coreService.getCrudService("te.TeTestCase");
        // // this.handleNavigationItems();
        //
        // this.queryParamSubscription = this.route.queryParams.subscribe(params => {
        //
        //     if (params['navItem']) {
        //         const exists = this.checkNavigationEntryExist( this.navigationItems, params['navItem']);
        //         if (exists) {
        //             this.selectedNavigationItem = params['navItem'];
        //             this.onNavItemSelection();
        //         } else {
        //             this.removeNavItemParam();
        //         }
        //     } else {
        //         this.selectedNavigationItem = null;
        //     }
        // });
        //
        // this.refreshTemplateBasicData();
        // this.refreshTestCases();
    }


    override onObjectChangedPost() {
        super.onObjectChangedPost();
        if (this.dto?.name) {
            this.setPageTitle(this.dto.name);
        }
    }

    /**
     * Save content.
     * @param event
     */
    handleEditorOnSave(event: TeEditorSaveEvent) {

        const dto = new TeTemplateDto();
        dto.id = this.dto.id;
        dto.content = event.content;
        dto.editorTypeEnum = event.editorTypeEnum;

        this.crudService.update(dto).subscribe({
            next: (value) => {
                this.dto.editorTypeEnum = event.editorTypeEnum;
                this.messageService.showSuccessMessageSaved();
                console.log('Updated content data into API');
                let editorContentFromCookie = this.autoSave.getAutoSaveCookie('te.TeTemplateVariable' + this.dto.id);
                if (editorContentFromCookie && dto.content === editorContentFromCookie?.content) {
                    this.autoSave.deleteAutoSaveCookie('te.TeTemplateVariable' + this.dto.id);
                }

                if (this.selectedNavigationItem == 'Selected Case') {
                    this.generateDocument();
                }

            },
            error: (error) => {
                this.messageService.showErrorMessage('Fehler', 'Ein Fehler ist aufgetreten.');
            }
        });

    }


    refreshTemplateBasicData() {
        this.widgetBasicData = WidgetFactory.createWidgetEntityData(
            'te.config.template.view',
            'Template',
            this.objectIdentifier.objectType,
            this.objectIdentifier.objectId
        );
    }

    toggleLeftSidebar() {
        this.leftSidebarOpen = !this.leftSidebarOpen;
    }

    toggleRightSidebar() {
        this.rightSidebarOpen = !this.rightSidebarOpen;
    }

    handleSelectTestCase(event: TestCaseChangeEvent) {
        this.selectedTestCase = event;

        // const exists = this.templateService.navigationItems.find(item => item.label == 'Selected Case');
        const exists = this.checkNavigationEntryExist( this.templateService.navigationItems, 'Selected Case');

        if (!exists) {
            this.templateService.navigationItems.push({ label: 'Selected Case',action: 'Selected Case', icon: 'fa-regular fa-file-pen' });
        }

    }

    checkNavigationEntryExist(items: NavigationItem[],label: string): boolean {
        const exists = items.find(item => item.label == label);
        if (exists) {
            return true;
        }
        return false;
    }

    // handleNavigationItems(navigationItems:NavigationItem[]) {
    //     // this.navigationItems = this.templateService.getObjectComponentNavigationItems();
    //     this.onNavigationItems.emit(this.navigationItems);
    // }

    removeNavItemParam(): void {
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['navItem'];
        this.router.navigate([], { queryParams: queryParams });
    }

    generateDocument() {

        this.templateGenerateResponse = null;
        this.occurredException = null;
        this.occurredExceptionDetails = null;

        const objectVariables: { [key: string]: ObjectIdentifierWithId } = {};
        const simpleVariables: { [key: string]: any } = {};

        // fill variables
        if (this.selectedTestCase.variables) {
            for (let variable of this.selectedTestCase.variables) {
                if (variable.useCaseVariable) {
                    if (variable.variableType == "object") {
                        objectVariables[variable.alias] = new ObjectIdentifierWithId(variable.useCaseVariable.objectTypeDtoId, null, variable.useCaseVariable.objectId);
                    } else if (variable.variableType == "simple") {
                        simpleVariables[variable.alias] = variable.useCaseVariable.simpleValue;
                    }
                }
            }
        }

        this.busy = true;

        this.templateService.generateViaTestCase(
            this.dto.id,
            this.selectedTestCase.dto.id,
            false,
            objectVariables,
            simpleVariables).subscribe({
            next: (value) => {
                if (value.errors || value.errorOccurred) {
                    this.occurredException = value.exception;
                    this.occurredExceptionDetails = value.exceptionDetails;
                } else {
                    this.templateGenerateResponse = value;
                    this.trustedGenerateResponseHtml = this.sanitizer.bypassSecurityTrustHtml(this.templateGenerateResponse.document);
                }
                this.busy = false;
            },
            error: (error) => {
                this.occurredException = 'Fehler bei der Template-Generierung';
                this.occurredExceptionDetails = error?.error?.message || error?.message || 'Unbekannter Fehler';
                this.busy = false;
            }
        });
    }

    onNavItemSelection() {
        if (this.selectedNavigationItem == 'Selected Case') {
            if (!this.templateGenerateResponse) {
                this.generateDocument();
            }
        }
    }

    refreshTestCases() {
        this.testCaseService.list(ObjectRequestList.createSimple(DtoImportObjectContext.createEmpty())).subscribe(value => {
            this.testCaseDtoList = value;
            this.busy = false;
        });
    }

    refreshTestCaseVariables() {

        const dtoListRequest = new ObjectRequestList(
            false,
            [FilterCriteria.create('testCase', FilterCriteria.cOperatorEqual, this.selectedTestCase.dto.id, null)],
            []
        );

        this.testCaseVariablesService.list(dtoListRequest).subscribe(res => {
            this.testCaseVariables = res.entries;
            this.refreshVariableMapping();
        });

    }

    refreshVariableMapping() {

        if (!this.selectedTestCase.variables) {
            return;
        }

        for (let variable of this.selectedTestCase.variables) {

            // set tu null
            variable.useCaseVariable = null;

            if (!this.testCaseVariables) {
                continue;
            }


            for (let testCaseVariable of this.testCaseVariables) {

                // check whether alias is set
                if (testCaseVariable.alias && testCaseVariable.alias !== variable.alias) {
                    continue;
                }

                // check whether types are matching
                if (variable.variableType == "object" && (testCaseVariable.type != TeVariableTypeEnum.object || variable.objectTypeDtoId != testCaseVariable.objectTypeDtoId)){
                    continue;
                } else if (variable.variableType == "simple" && testCaseVariable.type != TeVariableTypeEnum.simple){
                    continue;
                }


                let isMatch: boolean = false;

                // check for perfect match (including alias)
                if (variable.variableType == "object") {
                    if (variable.objectTypeDtoId && variable.objectTypeDtoId == testCaseVariable.objectTypeDtoId) {
                        isMatch = true;
                    }
                } else if (variable.variableType == "simple") {
                    isMatch = true;
                }

                variable.useCaseVariable = testCaseVariable;

                if (testCaseVariable.alias) {
                    // perfect match, we can stop any further processing
                    break;
                }

            }

        }

    }

}
